import VueI18n from "vue-i18n";
import Vue from "vue";
import en from "./langs/en.json";
import vi from "./langs/vi.json";
import km from "./langs/km.json";
import zhCn from "./langs/zh-CN.json";
import zhTw from "./langs/zh-TW.json";
import fa from "./langs/fa.json";
import fr from "./langs/fr.json";
import ru from "./langs/ru.json";
import ja from "./langs/ja.json";
import th from "./langs/th.json";
import lo from "./langs/lo.json";
import es from "./langs/es.json";
import it from "./langs/it.json";
import pt from "./langs/pt.json";
import tr from "./langs/tr.json";
import sv from "./langs/sv.json";
import id from "./langs/id.json";
import ko from "./langs/ko.json";
import ms from "./langs/ms.json";

Vue.use(VueI18n);
export default new VueI18n({
  locale: "en",
  fallbackLocale: "en",
  messages: {
    en,
    vi,
    km,
    "zh-cn": zhCn,
    "zh-tw": zhTw,
    fa,
    fr,
    ru,
    ja,
    th,
    lo,
    es,
    it,
    pt,
    tr,
    sv,
    id,
    ko,
    ms
  }
});
